import group from "./group/index.js";
import groupInput from "./group-input/index.js";
import groupOutput from "./group-output/index.js";

export default {
    group,
    groupInput,
    groupOutput
}